import { render, staticRenderFns } from "./GroupMessageInfoCard.vue?vue&type=template&id=522785b8&scoped=true&"
import script from "./GroupMessageInfoCard.vue?vue&type=script&lang=js&"
export * from "./GroupMessageInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupMessageInfoCard.vue?vue&type=style&index=0&id=522785b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522785b8",
  null
  
)

export default component.exports